function compare(a, b) {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }

  return String(a).localeCompare(b);
}

function toOperations(sortBy, prevFields) {
  if (prevFields === void 0) {
    prevFields = [];
  }

  var result = []; // Fill the result with sort operations

  for (var _i = 0, _a = Object.keys(sortBy); _i < _a.length; _i++) {
    var key = _a[_i];
    var value = sortBy[key];
    var fields = prevFields.concat([key]);

    if (typeof value === "object") {
      result.push.apply(result, toOperations(value, fields));
    } else {
      result.push({
        fields: fields,
        order: value
      });
    }
  } // Sort based on order


  result.sort(function (a, b) {
    return Math.abs(a.order) - Math.abs(b.order);
  });
  return result;
}
/**
 * Convert an input into an array of sort operations.
 */


function compile(sortBy) {
  switch (typeof sortBy) {
    case "object":
      if (Array.isArray(sortBy)) {
        return sortBy;
      }

      return toOperations(sortBy);

    case "string":
      return toOperations((_a = {}, _a[sortBy] = 1, _a));

    case "function":
      return [sortBy];

    default:
      return [];
  }

  var _a;
}

function isMap(maybeMap) {
  return !!(maybeMap && maybeMap["@@__IMMUTABLE_MAP__@@"]);
}

function get(obj, key) {
  if (isMap(obj)) {
    return obj.get(key);
  }

  return obj[key];
}

function getField(operation, entity) {
  return operation.fields.reduce(function (obj, field) {
    return get(obj, field);
  }, entity);
}

function getSimilarity(operation, a, b) {
  switch (typeof operation) {
    case "function":
      {
        var sortFunc = operation;
        return sortFunc(a, b);
      }

    case "object":
      {
        var fieldA = getField(operation, a);
        var fieldB = getField(operation, b);
        return operation.order < 0 ? compare(fieldB, fieldA) // Negative values represent a descend sorting operation.
        : compare(fieldA, fieldB); // Positive values represent an ascend sorting operation.
      }

    default:
      throw new Error("Operation is required to be a function or an object");
  }
}

function stableSort(a, b, operation, nextOperations) {
  if (!operation) return 0;
  var similarity = getSimilarity(operation, a, b);

  if (similarity === 0 && nextOperations.length) {
    return stableSort(a, b, nextOperations[0], nextOperations.slice(1));
  }

  return similarity;
}

function sort(array, sortBy) {
  var elements = array || [];
  var operations = compile(sortBy);
  return elements.sort(function (a, b) {
    return stableSort(a, b, operations[0], operations.slice(1));
  });
}

function inverse(sortBy) {
  var result = {};

  for (var _i = 0, _a = Object.keys(sortBy); _i < _a.length; _i++) {
    var key = _a[_i];
    var value = sortBy[key];

    switch (typeof value) {
      case "number":
        result[key] = value * -1;
        break;

      case "object":
        if (value && !Array.isArray(value)) {
          result[key] = inverse(value);
        }

        break;

      default:
        break;
    }
  }

  return result;
}

export { sort, inverse };